import React from "react";
import { Outlet } from "react-router";

export default function LeftPanel() {
  return (
    <div className="md:w-1/2 bg-zinc-50 p-6">
      <Outlet />
    </div>
  );
}
